import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe only once
export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '');